import { useState, useEffect } from 'react';  // Correct import for hooks
import SaveButtonWithModal from './SaveButtonWithModel';

const languages = [
  'Currently involved in Industry enterprise',
  'Have no experience but want to get involved in Industry enterprise',
  'Experienced in other industry enterprises',
  'Qualified but no experience. Want to get involved in Industry enterprises',
  'Experienced in other industry enterprises',
  'Have no experience. Want to get involved in Industry enterprises',
];

const GroupExperience = ({ selectedExperience = [], setSelectedExperience, onSave }) => {
  // Use the parent state if provided, otherwise local fallback (for preview/testing)
  const [internalSelected, setInternalSelected] = useState([]);
  const selected = setSelectedExperience ? selectedExperience : internalSelected;
  const setSelected = setSelectedExperience || setInternalSelected;

  const handleSelect = (lang) => {
    const newSelected = selected.includes(lang)
      ? selected.filter(item => item !== lang)
      : [...selected, lang];
    
    setSelected(newSelected);
    
    // Call onSave immediately when selection changes
    if (onSave) {
      onSave({
        typeOfGroupExperience: 'Personal, Group or Cooperative Experience',
        selectedExperience: newSelected
      });
    }
  };

  const handleSave = () => {
    if (onSave) {
      onSave({
        PersonalExperience: 'Personal, Group or Cooperative Experience',
        typeOfGroupExperience: 'Personal, Group or Cooperative Experience',
        selectedExperience: selected,
      });
    }
  };

  return (
    <div className='md:mt-4'>
      {/* Heading */}
      <div className='md:mt-6 mt-3'>
        <h1 className='md:text-[32px] text-[8px] font-bold'>
          Personal, Group or Cooperative Experience
        </h1>
        <p className='md:text-[24px] text-[6px] font-normal italic'>
          Select your experience, special interests and vision for your involvement in industry.
        </p>
      </div>

      {/* Selectable Buttons */}
      <div className="grid grid-cols-2 md:gap-2 gap-1 md:mt-6 mt-2">
        {languages.map((lang, i) => {
          const isActive = selected.includes(lang);
          return (
            <button
              key={i}
              onClick={() => handleSelect(lang)}
              className={`
                flex items-center justify-between
                w-full md:h-[70px] h-[20px] text-left
                rounded-[5px]
                md:px-4 px-2
                bg-[#E7EBEB]
              `}
            >
              <span className="font-medium text-[4px] md:text-[24px] leading-[1.10] md:w-[500px]">{lang}</span>
              <span
                className={`
                  md:w-14 md:h-14 w-3 h-3 rounded-full
                  ${isActive 
                    ? 'bg-[#2E453D] md:border-[8px] border-[3px] border-white'
                    : 'md:border-[8px] border-[3px] border-white bg-[#D9D9D9]'}
                `}
              />
            </button>
          );
        })}
      </div>

      <SaveButtonWithModal onSave={handleSave} />

      <div className="md:h-8 h-4"></div>
    </div>
  );
};

export default GroupExperience;